import React from 'react';
import GoogleMapReact from 'google-map-react';
import { Styles } from './styles/contact.js';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

const GoogleMap = ({ lat, lng, zoom = 15, markerText }) => {
    const center = { lat, lng };

    return (
        <Styles>
            {/* Google Map */}
            <div className="google-map-area">
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyATY4Rxc8jNvDpsK8ZetC7JyN4PFVYGCGM" }}
                    defaultCenter={center}
                    defaultZoom={zoom}
                >
                    <AnyReactComponent lat={lat} lng={lng} text={markerText} />
                </GoogleMapReact>
            </div>
        </Styles>
    )
}

export default GoogleMap
